import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_AmazingPediatricsReferralForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_AmazingPediatricsReferralForm' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <h1> <center>Georgia's Families In Transition LLC </center> </h1>
                </p>

                <p className='w-750'> <b> <center>REFERRAL INFORMATION </center> </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date of Referral: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Referring Agency Name: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateOfReferral' name='txtDateOfReferral' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtReferringAgencyName' name='txtReferringAgencyName' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Name & Position:</span> </td>
                        <td className='w-200'> <span className='eleHeader'> Phone #:</span> </td>
                        <td className='w-200'> <span className='eleHeader'> Email:</span> </td>
                    </tr>

                    <tr>
                        <td className='w-350'> <input type='text' id='txtNamePosition' name='txtNamePosition' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPhone' name='txtPhone' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtEmail' name='txtEmail' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> <center> CLIENT INFORMATION </center> </b> </p>

                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> First Name: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Last Name: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Age: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Gender: </span> </td>
                        <td className='w-500'> <span className='eleHeader'> Parent/Guardian: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                        <td className='w-500'>
                            <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Address: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-300'>
                            <input id='txtAddress' name='txtAddress' type='text' className='add-only' />
                        </td>

                        <td className='w-150'>
                            <input id='txtCity' name='txtCity' type='text' className='add-only' />
                        </td>

                        <td className='w-150'>
                            <input id='txtState' name='txtState' type='text' className='add-only' />
                        </td>

                        <td className='w-150'>
                            <input id='txtZip' name='txtZip' type='text' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Phone #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Cell #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Work: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input id='txtPhone' name='txtPhone' type='text' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input id='txtCell' name='txtCell' type='text' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input id='txtWork' name='txtWork' type='text' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Type of Insurance: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Medicaid/ Insurance ID </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input id='txtTypeOfInsurance' name='txtTypeOfInsurance' type='text' className='add-only' />
                        </td>

                        <td className='w-375'>
                            <input id='txtMedicaidInsuranceID' name='txtMedicaidInsuranceID' type='text' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Services Needed: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBehavioralHealthAssessment' name='cbBehavioralHealthAssessment' className='add-only' value='Behavioral Health Assessment' /> Behavioral Health Assessment <br />
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalEvaluation' name='cbPsychologicalEvaluation' className='add-only' value='Psychological Evaluation' /> Psychological Evaluation <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividualCounseling' name='cbIndividualCounseling' className='add-only' value='Individual Counseling' /> Individual Counseling <br />
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricEvaluation' name='cbPsychiatricEvaluation' className='add-only' value='Psychiatric Evaluation' /> Psychiatric Evaluation <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyGroupCounseling' name='cbFamilyGroupCounseling' className='add-only' value='Family & Group Counseling' /> Family & Group Counseling <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicationManagement' name='cbMedicationManagement' className='add-only' value='Medication Management' /> Medication Management <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParentSkillsTraining' name='cbParentSkillsTraining' className='add-only' value='Parent Skills Training' /> Parent Skills Training <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticAssessment' name='cbDiagnosticAssessment' className='add-only' value='Diagnostic Assessment ' /> Diagnostic Assessment <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialAndLifeSkillsTraining' name='cbSocialAndLifeSkillsTraining' className='add-only' value='Social and Life Skills Training' /> Social and Life Skills Training <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCommunityLinking' name='cbCommunityLinking' className='add-only' value='Community Linking' /> Community Linking <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfEsteemBuilding' name='cbSelfEsteemBuilding' className='add-only' value='Self-Esteem Building' /> Self-Esteem Building <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugs&Substance' name='cbDrugs&Substance' className='add-only' value='Drugs & Substance' /> Drugs & Substance <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNursingAssessmentServices' name='cbNursingAssessmentServices' className='add-only' value='Nursing Assessment Services' /> Nursing Assessment Services <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCopingSkills' name='cbCopingSkills' className='add-only' value='Coping/ Skills' /> Coping/ Skills <br />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisisIntervention' name='cbCrisisIntervention' className='add-only' value='Crisis Intervention' /> Crisis Intervention <br />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntensiveFamilyIntervention' name='cbIntensiveFamilyIntervention' className='add-only' value='Intensive Family Intervention' /> Intensive Family Intervention <br />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Has Psychiatric/Psychological evaluation been completed? </span>
                    <input type='radio' id='rbPsychiatricPsychological_Yes' name='rbPsychiatricPsychological' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychiatricPsychological_No' name='rbPsychiatricPsychological' className='add-only' value='No' /> No IF yes, please attach or provide attachment
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Is the person currently receiving counseling services? </span>
                    <input type='radio' id='rbCounselingServices_Yes' name='rbCounselingServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCounselingServices_No' name='rbCounselingServices' className='add-only' value='No' /> No  if yes we cannot discharge
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Is the person receiving medication? </span>
                    <input type='radio' id='rbReceivingMedication_Yes' name='rbReceivingMedication' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReceivingMedication_No' name='rbReceivingMedication' className='add-only' value='No' /> No   </p>

                <p className='w-750'>
                    <span className='eleHeader'> IF yes Name of Medication(s) and Dosage (text box) </span>
                    <input id='txtMedicationDosage' name='txtMedicationDosage' type='text' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'> Name of Physician: </span>
                    <input id='txtNameOfPhysician' name='txtNameOfPhysician' type='text' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Physician Address: </span>
                    <input id='txtPhysicianAddress' name='txtPhysicianAddress' type='text' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Physician Phone Number: </span>
                    <input id='txtPhysicianPhoneNumber' name='txtPhysicianPhoneNumber' type='text' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='small'>

                        Please email this form to: gafitllc@gmail.com or Fax (803-250-3427) If you have any questions please give us a call (678) 952-1548
                    </span>
                </p>






            </div>
        </form>

    )
}